// https://getfeals.com/?utm_source=seedcms&utm_medium=shopify&utm_campaign=seedtest&utm_id=123456&utm_term=cbd&utm_content=cbd
let urlParams = new URLSearchParams(window.location.search);

let add_item = urlParams.get('add_item');
let utm_id = urlParams.get('utm_id');
let utm_source = urlParams.get('utm_source');
let utm_medium = urlParams.get('utm_medium');
let utm_campaign = urlParams.get('utm_campaign');
let utm_term = urlParams.get('utm_term');
let utm_content = urlParams.get('utm_content');
let id = urlParams.get('id');
let selling_plan = urlParams.get('selling_plan');
let note = urlParams.get('note');

if (utm_id) {
  localStorage.setItem("utm_id", utm_id);
}

if (utm_source) {
  localStorage.setItem("utm_source", utm_source);
}

if (utm_medium) {
  localStorage.setItem("utm_medium", utm_medium);
}

if (utm_campaign) {
  localStorage.setItem("utm_campaign", utm_campaign);
}

if (utm_term) {
  localStorage.setItem("utm_term", utm_term);
}

if (utm_content) {
  localStorage.setItem("utm_content", utm_content);
}

if(add_item === '1') {
  window.location.href = `/cart/add?id=${id}&selling_plan=${selling_plan}&note=${note}` 
}

// alert(utm_id,utm_source,utm_medium,utm_campaign,utm_term,utm_content)
// console.log('============= START ===================')
// console.log(utm_id,utm_source,utm_medium,utm_campaign,utm_term,utm_content)
// console.log('============= END ===================')
